module.exports = __webpack_public_path__ + "static/media/home_appointments.7f359c7e.png";